import { v1 as UUID } from "uuid";
// 问题类：多项填空
let Option2 = function(labelName) {
	this.oid = UUID();
    this.labelName = labelName || '';
    this.mustanswer = true
    this.minNum = 0 // 最小限制字数/数字最小值
    this.maxNum = 0 // 最大限制字数/数字最大值
    this.decimalPlaces = 0 // 保留小数位数
    this.answer = ''
    this.format = 0 // 输入框格式
    this.placeholder = ''
    this.inputHeight = '小' // 输入框高度(多项填空)
    this.optionScore = 5 // 当前填空的分数（用于答对几项得几分）
    this.isDefault = true // 标识为默认选项
}

export default Option2;